@if (embedUrl) {
  <div>
    <iframe
      [src]="embedUrl | safe"
      frameborder="0"
      allowfullscreen
      class="video-iframe"
    ></iframe>
  </div>
}
